import React from "react";

const API_BASE = (process.env.REACT_APP_API_URL || "http://localhost:8081").replace(/\/$/, "");
// Default to /api/health because this app's API routes live under /api.
const HEALTH_PATH = (process.env.REACT_APP_HEALTH_PATH || "/api/health").startsWith("/")
  ? process.env.REACT_APP_HEALTH_PATH || "/api/health"
  : `/${process.env.REACT_APP_HEALTH_PATH || "api/health"}`;

/**
 * Ping backend every 5s to reduce cold start impact.
 * - Pauses when tab is hidden.
 * - Guards against StrictMode double-mount in dev.
 */
export default function HealthPinger() {
  const startedRef = React.useRef(false);
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const url = `${API_BASE}${HEALTH_PATH}`;

    const ping = async () => {
      try {
        // Keep it lightweight; ignore response body.
        await fetch(url, { method: "GET", cache: "no-store" });
      } catch {
        // ignore
      }
    };

    const ensure = () => {
      const visible = typeof document === "undefined" ? true : document.visibilityState === "visible";
      if (!visible) {
        if (timerRef.current) {
          clearInterval(timerRef.current);
          timerRef.current = null;
        }
        return;
      }
      if (!timerRef.current) {
        ping();
        timerRef.current = setInterval(ping, 5000);
      }
    };

    ensure();
    document.addEventListener("visibilitychange", ensure);

    return () => {
      document.removeEventListener("visibilitychange", ensure);
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, []);

  return null;
}

